import script from "./AudienceFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceFooter.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceFooter.vue?vue&type=style&index=0&id=68030d9c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68030d9c"]])

export default __exports__